import { useState } from "react";
import { toast } from "sonner";

const copy = async (text, label) => {
  try {
    await navigator.clipboard.writeText(text);
    toast(`${label} copied.`);
  } catch {
    toast("Could not copy. Select and copy manually.");
  }
};

export const CampaignPostCard = ({ post }) => {
  const [open, setOpen] = useState(false);

  return (
    <article
      data-testid={`campaign-post-${post.id}`}
      className="border border-[color:var(--rule)] bg-white/40"
    >
      <div className="relative">
        <img
          src={post.image}
          alt={post.title}
          className="w-full h-auto"
          loading="lazy"
        />
        <span className="absolute top-3 left-3 hairline bg-[color:var(--ink)] text-[color:var(--bone)] px-3 py-1.5">
          Post {String(post.no).padStart(2, "0")} · Week {post.week}
        </span>
      </div>

      <div className="p-6 md:p-8">
        <p className="hairline opacity-60">{post.platform}</p>
        <h3 className="font-serif italic text-2xl md:text-3xl mt-2 leading-[1.1]">
          {post.title}
        </h3>
        <p className="font-serif italic text-base opacity-70 mt-2">
          {post.theme}
        </p>

        <div className="mt-5 space-y-1.5 text-sm">
          <p className="font-mono text-xs opacity-70">{post.timing}</p>
          <p className="font-mono text-xs opacity-70">{post.format}</p>
        </div>

        <div className="mt-6 flex flex-wrap gap-x-6 gap-y-3">
          <button
            type="button"
            onClick={() => copy(post.caption, "Caption")}
            className="link-quiet font-serif italic text-base"
            data-testid={`copy-caption-${post.id}`}
          >
            Copy caption
          </button>
          <button
            type="button"
            onClick={() => copy(post.hashtags, "Hashtags")}
            className="link-quiet font-serif italic text-base"
            data-testid={`copy-hashtags-${post.id}`}
          >
            Copy hashtags
          </button>
          <a
            href={post.image}
            download={`nick-fraser-${post.id}.png`}
            className="link-quiet font-serif italic text-base"
            data-testid={`download-graphic-${post.id}`}
          >
            Download graphic
          </a>
          <button
            type="button"
            onClick={() => setOpen((v) => !v)}
            className="link-quiet font-serif italic text-base opacity-70"
            data-testid={`toggle-details-${post.id}`}
          >
            {open ? "Hide details" : "Full brief"}
          </button>
        </div>

        {open && (
          <div className="mt-8 space-y-6 border-t border-[color:var(--rule)] pt-6">
            <div>
              <p className="hairline opacity-50 mb-2">Visual concept</p>
              <p className="font-serif text-base leading-[1.5]">{post.visual}</p>
            </div>
            <div>
              <p className="hairline opacity-50 mb-2">Text on graphic</p>
              <p className="font-mono text-xs leading-[1.7] opacity-80">
                {post.graphicText}
              </p>
            </div>
            <div>
              <p className="hairline opacity-50 mb-2">Caption</p>
              <p className="font-serif text-base leading-[1.55] whitespace-pre-line">
                {post.caption}
              </p>
            </div>
            <div>
              <p className="hairline opacity-50 mb-2">Hashtags</p>
              <p className="font-mono text-xs leading-[1.7] opacity-80">
                {post.hashtags}
              </p>
            </div>
            <div>
              <p className="hairline opacity-50 mb-2">Suggested asset</p>
              <p className="font-serif text-base leading-[1.5]">{post.asset}</p>
            </div>
            <div>
              <p className="hairline opacity-50 mb-2">Call to action</p>
              <p className="font-serif italic text-base">{post.cta}</p>
            </div>
          </div>
        )}
      </div>
    </article>
  );
};
